import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PartnerPluginActivateBase from './PartnerPluginActivateBase';
import PartnerPluginActivateMultiStep from './PartnerPluginActivateMultiStep';
import { useLanguageUtm } from '../Common';
import usePageTitle from '../Common/Hooks/usePageTitle';

export const HyperisePlaceholderContainer = styled.div`
  width: 100%;
  height: fit-content;
`;

export const hasSliideOrigin = () => {
  return window.location.search.includes('utm_campaign=sliide');
};

const PartnerpluginsdkActivate = () => {
  useLanguageUtm();
  usePageTitle();
  const [hasExperimentOrigin, setHasExperimentOrigin] = useState(false);
  const [sliide] = useState(hasSliideOrigin());

  useEffect(() => {
    const hasKindredOrigin = window.location.search.includes('origin=kindred');

    setHasExperimentOrigin(hasKindredOrigin || hasSliideOrigin());
  }, []);

  return hasExperimentOrigin ? (
    <PartnerPluginActivateMultiStep sliide={sliide} />
  ) : (
    <PartnerPluginActivateBase />
  );
};

export default PartnerpluginsdkActivate;
